import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { RouteChildrenProps } from "react-router";
import { ReportActivitiesEnum, ReportStatesEnum } from "../../../../constants/constants";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import { ReivewRequestModel, ReviewModel } from "../../../../models/review.model";
import { ScenarioFrontierModel } from "../../../../models/scenario-frontier.model";
import { setStatus, setTitle } from "../../../../redux/actions/header.action";
import { ScenarioFrontierService } from "../../../../services/scenario-frontier.service";
import { ROLE_GUARD } from "../../../../utils/role-guard";
import UTIL from "../../../../utils/utils";
import FooterAction from "../../../atoms/footer-action";
import AppReview from "../../../atoms/review";
import FrontierOutput from "../new-report/output";
import { quarters } from "../select-period";
import "./index.scss";
import Information from "./infomation";

interface Props extends RouteChildrenProps<{ id: string }> { }

const FrontierReportDetails = (props: Props) => {

    const { t } = useTranslation();
    const [data, setData] = useState<ScenarioFrontierModel>();
    const id = useRef<number>();
    const dispatch = useDispatch();
    const [newReview, setNewReview] = useState<ReviewModel>();
    const [reviewData, setReviewData] = useState<ReviewModel[]>();
    const [isReviewReport, setIsReviewReport] = useState<boolean>();

    const updateStatus = (submit_state: string) => {
        const dom = UTIL.getLossStatesDOM(submit_state);
        const status = <span className="text-status" style={{ color: dom.color, backgroundColor: dom.bgColor }}>
            {dom.text}
        </span>
        dispatch(setStatus(status));
    }

    const action = async (actionType: ReportActivitiesEnum, messgae: string = "") => {
        if (data?.id) {
            const model: ReivewRequestModel = {
                message: messgae,
                reportId: data?.id,
                action: actionType
            }

            const review = await ScenarioFrontierService.approvalAction(model);

            if (actionType !== ReportActivitiesEnum.Comment) {
                setNewReview(review.data);
                if (actionType === ReportActivitiesEnum.Approve) {
                    data.submit_state = ReportStatesEnum.Approved;
                } else if (actionType === ReportActivitiesEnum.Refer) {
                    data.submit_state = ReportStatesEnum.Rejected;
                }
                setData({ ...data });
            }
        }
    }

    useEffect(() => {
        if (data?.submit_state) {
            updateStatus(data.submit_state);
        }
    }, [data?.submit_state])

    useEffect(() => {

        id.current = Number(props.match?.params.id);
        setIsReviewReport(props.location.pathname.includes(ROUTE_PATHS.ScenarioFrontierReviewReport));

        ScenarioFrontierService.getReportById(id.current).then(res => {
            setData(res.data)
            setReviewData(res.data.frontierReviews);
            dispatch(setTitle(`Scenario Report - ${res.data.fiscalYear} - ${quarters.find(x => x.value === res.data.quarter)?.text}`));
        });


        return () => {
            dispatch(setTitle(""))
            dispatch(setStatus(null))
        };
    }, [dispatch, props.location.pathname, props.match?.params.id])

    return (

        <div className="frontiter-report-details-wrapper">
            <div className="section-wrapper info-wrapper">
                <h4>
                    {t("EcapModule.lbInformation")}
                </h4>

                <Information data={data} />
            </div>
            <div className="section-wrapper">
                {
                    !!data && <FrontierOutput
                        id={data.id}
                        data={data.frontierOutputFiles}
                        year={data.fiscalYear || 0} quarter={data.quarter || 0}
                        includeConcentrationStressTest={data.includeConcentrationStressTest} />
                }

            </div>

            {UTIL.CheckShowReviewByState(data?.submit_state) &&
                <AppReview newReview={newReview} comment={(message) => action(ReportActivitiesEnum.Comment, message)} data={reviewData} showInputComment={ROLE_GUARD.hasApproverRole()} />}

            {data?.submit_state === ReportStatesEnum.Submitted && ROLE_GUARD.hasApproverRole() &&
                isReviewReport &&
                <FooterAction onApprove={() => action(ReportActivitiesEnum.Approve)} onRefer={() => action(ReportActivitiesEnum.Refer)} />}
        </div>

    )
}

export default FrontierReportDetails;